





















































































































































































































































import Snackbar from '@/components/shared/Snackbar.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import ITransformationsProducts from '@/store/models/ITransformationsProducts';
import IListPalletType from '@/store/models/IListPalletType';
import ITransformationsPalletsDestination from '@/store/models/ITransformationsPalletsDestination';
import ITransformationsPalletsSource from '@/store/models/ITransformationsPalletsSource';
import ITransformations from '@/store/models/ITransformations';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
        Snackbar
    }
})
export default class TransformationsPalletsSelector extends Vue {
@Prop({ type: Array, required: true })
Permissions !: IRolePermission[];
@Prop({ type: Array, required: true })
StockList !: IStock[];
@Prop({ type: Array, required: true })
ListPalletTypes !: IListPalletType[];
@Prop({ type: Array, required: true })
TransformationPalletsDestinationList !: ITransformationsPalletsDestination[];
@Prop({ type: Array, required: true })
TransformationPalletsSourceList !: ITransformationsPalletsSource[];
@Prop({ type: Array, required: true })
ProductsTransformationList !: ITransformationsProducts[]
@Prop()
SelectedTransformation !: ITransformations;

headersStockToTransform: any = [
    { text: 'Good',
        align: 'start',
        value: 'goodName'
    },
    { text: 'Inb. Dossier Number Source', value: 'codeInbounds' },
    { text: 'Inb. Dossier Number Destination', value: 'codeDestination' },
    { text: 'Warehouse', value: 'warehouseName' },
    { text: 'Pallet type', value: 'listPalletName' },
    { text: 'Pallet Id', value: 'idPallet' },
    { text: 'Location', value: 'location' },
    { text: 'Total cases', value: 'totalCases' },
    { text: 'Goods per case', value: 'goodsPerCase' }
];

headersTransformationPalletSource: any = [
    { text: 'Good',
        align: 'start',
        value: 'goodName'
    },
    { text: 'Pallet Id', value: 'idPallet' },
    { text: 'Goods per case', value: 'goodsPerCase' },
    { text: 'Total cases', value: 'totalCases' }
]

headersProductsToTransform: any = [
    { text: 'Good',
        align: 'start',
        value: 'goodName'
    },
    { text: 'Total cases Available', value: 'totalCasesAvailable' },
    { text: 'Goods per case', value: 'goodsPerCase' },
    { text: 'Total cases in use', value: 'totalCasesInUse' },
    { text: 'Actions', value: 'actions', sortable: false }
];

headersTransformationPalletDestination: any = [
    { text: 'Good',
        align: 'start',
        value: 'goodName'
    },
    { text: 'Pallet amount', value: 'palletAmount' },
    { text: 'Pallet type', value: 'palletName' },
    { text: 'Cases per pallet', value: 'casesPerPallet' },
    { text: 'Location', value: 'location' },
    { text: 'Actions', value: 'actions', sortable: false }
];

editedItem: ITransformationsPalletsDestination = {
    id: "",
    palletAmount: 0,
    idListPallet: "",
    palletName: "",
    idGood: "",
    goodName: "",
    casesPerPallet: 0,
    goodsPerCase: 0,
    location: "",
    idTransformation: ""
}
defaultItem: ITransformationsPalletsDestination = {
    id: "",
    palletAmount: 0,
    idListPallet: "",
    palletName: "",
    idGood: "",
    goodName: "",
    casesPerPallet: 0,
    goodsPerCase: 0,
    location: "",
    idTransformation: ""
}
sortBy: string = 'goodName';
sortDesc: boolean = false;
selectedProductName: string = "";
selectedPalletsSource: IStock[] = [];
selectedTransformationProduct: ITransformationsProducts[] = [];
selectedPalletType: IListPalletType = {} as IListPalletType;
selectedTransformationPalletDestination: ITransformationsPalletsDestination[] = [];
dialog: boolean = false;
isValid: boolean = true;
editedIndex : number = -1;
dialogShowSource: boolean = false;
get ListProductsTransformation() {
    return this.StockList.map(item => item.goodName).filter((value, index, self) => self.indexOf(value) === index);
}

get canAddProducts() {
    if (this.SelectedTransformation.statusName.toLowerCase() === 'completed') {
        return false;
    }
    return true;
}

get StockListFiltered(): IStock[] {
    if (this.selectedProductName) {
        if (this.ProductsTransformationList.length > 0) {
            let stockListSelectedProduct = this.StockList.filter(i => i.goodName === this.selectedProductName);
            if (this.TransformationPalletsSourceList.length > 0) {
                let transformationDestination = this.TransformationPalletsSourceList.filter(i => i.goodName === this.selectedProductName);
                let idPallets = transformationDestination.map(p => p.idPallet.trim());
                stockListSelectedProduct = stockListSelectedProduct.filter(p => idPallets.indexOf(p.idPallet) === -1);
            }
            let palletsIdsProductsTransformationList: string[] = [];
            this.ProductsTransformationList.forEach(r => {
                if (r.palletsSource.length > 0) {
                    r.palletsSource.forEach(v => {
                        palletsIdsProductsTransformationList.push(v.idPallet);
                    });
                }
            });
            if (palletsIdsProductsTransformationList.length > 0) {
                return stockListSelectedProduct
                .filter(p => palletsIdsProductsTransformationList.indexOf(p.idPallet) === -1)
                .sort((a, b) => b.totalGoods - a.totalGoods);
            }
            return stockListSelectedProduct.sort((a, b) => b.totalGoods - a.totalGoods);
        } else {
            let transformationDestination = this.TransformationPalletsSourceList.filter(i => i.goodName === this.selectedProductName);
            let idPallets = transformationDestination.map(p => p.idPallet.trim());
            return this.StockList
            .filter(p => idPallets.indexOf(p.idPallet) === -1 && p.goodName === this.selectedProductName)
            .sort((a, b) => b.totalGoods - a.totalGoods);
        }
    }
    return [];
}

get ProductPalletSourceFiltered() : ITransformationsPalletsSource[] {
    if (this.ProductsTransformationList.length > 0) {
        if (this.TransformationPalletsSourceList.length > 0) {
            return this.TransformationPalletsSourceList.filter(i => i.idGood === this.ProductsTransformationList[0].idGood);
        }
    }
    return [];
}
isCompleted() {
    return this.SelectedTransformation.statusName.toLocaleLowerCase() !== 'completed';
}

@Watch('dialog')
onDialogChanged(val: any) {
    val || this.close();
}

close() : void {
    this.dialog = false;
    this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectedPalletType = {} as IListPalletType;
    });
}

@Watch('dialogShowSource')
onDialogShowSourceChanged(val: any) {
    val || this.closeShowPalletsSource();
}

closeShowPalletsSource() : void {
    this.dialogShowSource = false;
}

getColor(item: ITransformationsProducts) {
    if (item.totalCasesInUse === null) {
        item.totalCasesInUse = 0;
        return 'white';
    } else if (item.totalCasesInUse < item.totalCasesAvailable) return 'orange';
    else if (item.totalCasesInUse === item.totalCasesAvailable) return 'green';
    item.totalCasesInUse = 0;
    return 'white';
}

addTransformationProduct() {
    if (this.selectedPalletsSource.length > 0) {
        const goodsPerCaseSet = new Set(this.selectedPalletsSource.map(pallet => pallet.goodsPerCase));
        if (goodsPerCaseSet.size > 1) {
            this.showMessageWarning("The selected pallets have different 'goodsPerCase' values.");
            return;
        }

        let totalCasesAvailable = this.selectedPalletsSource.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
        let index = this.ProductsTransformationList.findIndex(p => p.idGood === this.selectedPalletsSource[0].idGood && p.goodsPerCase === this.selectedPalletsSource[0].goodsPerCase);
        if (index === -1) {
            let product: ITransformationsProducts = {
                id: uuidv4(),
                idGood: this.selectedPalletsSource[0].idGood,
                goodName: this.selectedPalletsSource[0].goodName,
                totalCasesAvailable: totalCasesAvailable,
                totalCasesInUse: 0,
                palletsSource: this.selectedPalletsSource,
                goodsPerCase: this.selectedPalletsSource[0].goodsPerCase
            };
            this.ProductsTransformationList.push(product);
        } else {
            this.ProductsTransformationList[index].totalCasesAvailable = this.ProductsTransformationList[index].totalCasesAvailable + totalCasesAvailable;
            this.ProductsTransformationList[index].palletsSource = this.ProductsTransformationList[index].palletsSource.concat(this.selectedPalletsSource);
        }
        this.selectedPalletsSource = [];
    }
}

get TransformationPalletsDestinationFiltered() {
    if (this.selectedTransformationProduct.length > 0 && this.TransformationPalletsDestinationList.length > 0) {
        return this.TransformationPalletsDestinationList.filter(i => this.selectedTransformationProduct[0].idGood === i.idGood && i.goodsPerCase === this.selectedTransformationProduct[0].goodsPerCase);
    }
    return [];
}

get TotalCasesAvailable() {
    let totalCasesAvailable = this.selectedTransformationProduct[0].totalCasesAvailable;// - this.selectedTransformationProduct[0].totalCasesInUse;
    let totalCasesTransformated = this.TransformationPalletsDestinationFiltered.reduce((acc, item) => acc + item.palletAmount * item.casesPerPallet, 0);
    return totalCasesAvailable - totalCasesTransformated;
}

saveTransformationPalletDestination() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.selectedPalletType.id === undefined) {
            this.showMessageWarning("Pallet type is required");
        } else if (this.editedItem.palletAmount * this.editedItem.casesPerPallet > this.TotalCasesAvailable) {
            this.showMessageWarning("The number of pallet amounts and cases is higher than the maximum allowed.");
        } else {
            this.editedItem.idListPallet = this.selectedPalletType.id;
            this.editedItem.palletName = this.selectedPalletType.name;
            this.editedItem.idGood = this.selectedTransformationProduct[0].idGood;
            this.editedItem.goodName = this.selectedTransformationProduct[0].goodName;
            this.editedItem.goodsPerCase = this.selectedTransformationProduct[0].goodsPerCase;
            if (this.selectedTransformationProduct[0].palletsSource.length > 0) {
                this.editedItem.goodsPerCase = this.selectedTransformationProduct[0].palletsSource[0].goodsPerCase;
            }
            let palletSources : IStock[] = [];
            this.ProductsTransformationList.forEach(p => {
                if (p.palletsSource.length > 0) {
                    p.palletsSource.forEach(p => {
                        palletSources.push(p);
                    });
                }
            });
            this.$emit("saveTransformationPalletDestination", this.editedItem, palletSources);
            this.updateProductsTransformationList();
            this.close();
        }
    } else {
        this.showMessageWarning("All required fields must be filled out");
    }
}

updateProductsTransformationList() {
    let index = this.ProductsTransformationList.findIndex(t => t.idGood === this.editedItem.idGood && t.goodsPerCase === this.editedItem.goodsPerCase);
    if (index !== -1) {
        this.ProductsTransformationList[index].totalCasesInUse = this.ProductsTransformationList[index].totalCasesInUse + (this.editedItem.palletAmount * this.editedItem.casesPerPallet);
    }
}

deleteTransformationPalletsDestination(item: ITransformationsPalletsDestination) {
    this.$emit("deleteTransformationPalletsDestination", item, true);
    let index = this.ProductsTransformationList.findIndex(t => t.idGood === item.idGood && t.goodsPerCase === this.editedItem.goodsPerCase);
    if (index !== -1) {
        this.ProductsTransformationList[index].totalCasesInUse = this.ProductsTransformationList[index].totalCasesInUse - (item.palletAmount * item.casesPerPallet);
    }
}
deleteProductTransformation(item: ITransformationsProducts) {
    let transformations = this.TransformationPalletsDestinationList.filter(
        t => t.idGood === item.idGood && t.goodsPerCase === item.goodsPerCase
    );
    let isFirst = true;
    for (const transformation of transformations) {
        try {
            this.$emit("deleteTransformationPalletsDestination", transformation, isFirst);
            isFirst = false;
        } catch (error) {
            this.showMessageError(`Failed to delete transformation: ${transformation.id}`);
            return;
        }
    }

    let index = this.ProductsTransformationList.findIndex(
        t => t.idGood === item.idGood && t.goodsPerCase === item.goodsPerCase
    );
    if (index !== -1) {
        this.ProductsTransformationList.splice(index, 1);
    }
}

showPalletsSource() {
    
}

showMessageInfo(message: string) {
    (this.$refs.snackbar as Snackbar).showInfo(message);
}

showMessageError(message: string) {
    (this.$refs.snackbar as Snackbar).showError(message);
}

showMessageWarning(message: string) {
    (this.$refs.snackbar as Snackbar).showWarning(message);
}
}
